<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div demo class="ui info message">
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 7.5V10.625M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 13.125H10.0063V13.1313H10V13.125Z"
      stroke="#202223"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <p>
    Please note:
    <span
      >Any changes made here will be verified before it appears on your
      profile</span
    >
  </p>
</div>
<div class="content" style="padding-top: 0px">
  <div
    class="scroll-wrapper ui basic segment"
    appPadding
    paddingT="0"
    [ngClass]="{ loading: pending }"
    appMargin="0"
    appPadding="0"
  >
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
    <div class="ui one column grid" appMargin marginB="10px">
      <div class="ui column">
        <h2
          class="ui text"
          style="
            font-family: Roboto;
            font-size: 14px;
            font-weight: 700;
            line-height: 19.6px;
            text-align: left;
            color: #505050;
          "
        >
          {{ documentsType.documentTypeName }}
        </h2>
      </div>
    </div>
    <div class="ui form" [formGroup]="replyForm">
      <div
        class="field"
        [ngClass]="displayFieldCss('document')"
        *ngIf="uploadedFiles?.length === 0"
      >
        <div class="ui segment" style="border-radius: 8px">
          <div fxFlex="row" fxLayoutAlign="start center">
            <div fxFlex="24px"><div class="bordered-square"></div></div>
            <div style="margin-left: 30px">
              {{ fileName ? fileName : "Upload Document" }}
            </div>
            <div fxFlex fxLayoutAlign="end">
              <input
                formControlName="document"
                type="file"
                accept=".jpg, .jpeg, .png, .JPG, .JPEG,.pdf"
                #uploader
                (change)="onFileChange($event)"
                placeholder="Upload Document"
                onclick="value = null"
                style="display: none"
              />
              <div
                class="ui button"
                (click)="uploader.click()"
                style="
                  background-color: #3f4395;
                  border-radius: 8px;
                  color: #ffffff;
                "
              >
                Browse
              </div>
            </div>
          </div>
        </div>
        <app-field-error-display
          [displayError]="isFieldValid('document')"
          errorMsg="Please select file"
        >
        </app-field-error-display>
      </div>
      <div *ngIf="uploadedFiles?.length > 0">
        <div class="headers" *ngIf="firstShow">
          <h2
            class="ui text"
            style="
              font-family: Roboto;
              font-size: 12px;
              font-weight: 700;
              line-height: 18px;
              text-align: left;
              color: #505050;
            "
          >
            {{ replyForm.value.documentName }}
          </h2>
          <div (click)="editName()" style="cursor: pointer">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="9" fill="#F0F1F8" />
              <g clip-path="url(#clip0_8808_19974)">
                <path
                  d="M12.3105 5.68954C12.0271 5.40609 11.6502 5.25 11.2494 5.25C10.8486 5.25 10.4717 5.40609 10.1883 5.68953L5.99452 9.88332C5.95883 9.919 5.93298 9.9633 5.91944 10.0119L5.26073 12.3785C5.23233 12.4805 5.26123 12.59 5.33636 12.6647C5.39203 12.7201 5.46662 12.75 5.54299 12.75C5.56968 12.75 5.59661 12.7463 5.62302 12.7388L7.98958 12.0666C8.08942 12.0382 8.16682 11.9592 8.19301 11.8587C8.2192 11.7583 8.19029 11.6515 8.117 11.5779L6.62503 10.0814L10.1013 6.60514L11.3942 7.89798L8.73293 10.552C8.61836 10.6662 8.61811 10.8517 8.73237 10.9663C8.84661 11.0809 9.03213 11.0811 9.14669 10.9669L12.3105 7.8117C12.5939 7.52827 12.75 7.15144 12.75 6.75062C12.75 6.34979 12.5939 5.97296 12.3105 5.68954ZM7.35051 11.639L5.96524 12.0325L6.3532 10.6387L7.35051 11.639ZM11.8964 7.39709L11.8091 7.48424L10.5157 6.19083L10.6026 6.10384C10.7754 5.93108 11.0051 5.83594 11.2494 5.83594C11.4937 5.83594 11.7234 5.93108 11.8962 6.10386C12.0689 6.27661 12.1641 6.50629 12.1641 6.75062C12.1641 6.99494 12.0689 7.22462 11.8964 7.39709Z"
                  fill="#86879D"
                />
              </g>
              <defs>
                <clipPath id="clip0_8808_19974">
                  <rect
                    width="7.5"
                    height="7.5"
                    fill="white"
                    transform="translate(5.25 5.25)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
        <div class="headers_input" *ngIf="secondShow">
          <div class="headers">
            <h2
              class="ui text"
              style="
                font-family: Roboto;
                font-size: 12px;
                font-weight: 400;
                line-height: 18px;
                text-align: left;
                color: #505050;
                margin: 0;
                padding: 0;
              "
            >
              Document Name
            </h2>
            <!-- <div style="display: flex; align-items: center; gap: 8px">
              <p
                style="
                  font-family: Roboto;
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 16px;
                  text-align: center;
                  color: #bdc1cc;
                  cursor: pointer;
                  padding: 0;
                  margin: 0;
                "
                (click)="revert()"
              >
                Cancel
              </p>
              <p
                style="
                  font-family: Roboto;
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 16px;
                  text-align: center;
                  color: #2c6ecb;
                  cursor: pointer;
                  padding: 0;
                "
                (click)="saveName()"
              >
                Save
              </p>
            </div> -->
          </div>
          <div>
            <input
              formControlName="documentName"
              type="text"
              placeholder="name"
              style="margin-bottom: 16px"
            />
          </div>
        </div>
        <div class="added_document">
          <div class="contents">
            <div class="image">
              <img src="assets/icons/Frame.svg" alt="" />
            </div>
            <div class="content_name">
              <h5
                style="
                  width: 200px; /* Set the width of the container */
                  overflow: hidden; /* Hide overflowing content */
                  white-space: nowrap; /* Prevent text from wrapping */
                  text-overflow: ellipsis; /* Show an ellipsis (...) for overflowed text */
                "
              >
                {{
                  uploadedFiles[0].name
                    ? uploadedFiles[0].name
                    : uploadedFiles[0].documentId.documentName
                }}
              </h5>
            </div>
          </div>
          <div
            class="action_button"
            style="display: flex; align-items: center; gap: 8px"
          >
            <img
              src="assets/icons/Frame 5492.svg"
              suiPopup
              [popupInverted]="true"
              popupPlacement="bottom"
              popupText="View"
              (click)="viewFiles(uploadedFiles[0])"
              alt=""
            />
            <img
              src="assets/icons/trash.svg"
              (click)="removeFileNew(0)"
              alt=""
            />
          </div>
        </div>
      </div>

      <!-- <form
        class="ui form"
        appMargin
        style="margin-bottom: 30px; flex-direction: column; margin-top: 30px"
        *ngIf="uploads.length > 0"
      >
        <h2 class="ui head" fxFlex="auto">Upload Supporting Document</h2>
        <p>
          Click the plus (+) button to upload new document. You can link any
          similar document you have uploaded before now by choosing the Link
          option. Only .pdf, .doc and .ppt files can be uploaded
        </p>
        <div>
          <div
            *ngFor="let document of documentss; let i = index"
            style="margin-bottom: 20px"
          >
            <div fxLayout="row" style="width: 100%">
              <label
                fxFlex="auto"
                [ngClass]="{ required: document.isRequired }"
              >
                Upload {{ document.documentTypeName }}
              </label>
              <div suiDropdown>
                <button
                  class="ui tiny icon button"
                  style="
                    border: none !important;
                    align-items: center !important;
                  "
                  style="float: right"
                  *ngIf="
                    !(
                      toEdit == 'TIN' &&
                      proceedToSubmitTin &&
                      (document.uploadedFiles.length > 0 ||
                        returnDocumentType(
                          allLinkedDocuments,
                          document.documentTypeName
                        ).length > 0)
                    )
                  "
                >
                  <i
                    class="ui plus icon hoverable"
                    suiPopup
                    [popupInverted]="true"
                    popupPlacement="bottom"
                    popupText="upload Document"
                  ></i>
                </button>
                <div
                  class="menu"
                  style="margin-top: 20px"
                  suiDropdownMenu
                  appPadding
                  paddingX="3"
                >
                  <div
                    class="item"
                    style="
                      padding: 16px 0px;
                      color: #3f4395;
                      font-size: 14px;
                      font-weight: 500;
                      cursor: pointer;
                    "
                    (click)="uploader.click()"
                  >
                    <input
                      #uploadDoc
                      type="file"
                      accept=".pdf,.doc,.docx,.odf:not(.zip),.xls,.xlsx"
                      #uploader
                      multiple
                      (change)="onFileChanges($event, document)"
                      placeholder="Browse for documents"
                      onclick="value = null"
                      style="display: none"
                    />
                    Upload new document
                  </div>
                  <a
                    class="item"
                    style="
                      padding: 16px 0px;
                      color: #3f4395;
                      font-size: 14px;
                      font-weight: 500;
                      cursor: pointer;
                    "
                    (click)="LinkDocument(document.documentTypeName)"
                    >Link an existing document</a
                  >
                </div>
              </div>
            </div>
            <div
              style="width: 100%"
              class="ui divider"
              appMargin
              marginT="1"
            ></div>
            <div
              *ngIf="
                returnDocumentType(
                  allLinkedDocuments,
                  document.documentTypeName
                ).length > 0
              "
              style="width: 100%"
              class="field"
              appMargin
              marginT="5px"
            >
              <div
                class="item"
                style="
                  padding: 16px 0px;
                  color: #3f4395;
                  font-size: 14px;
                  font-weight: 500;
                "
              >
                Linked existing documents of {{ document.documentTypeName }}
              </div>
              <ng-container class="document">
                <div
                  *ngFor="
                    let doc of returnDocumentType(
                      allLinkedDocuments,
                      document.documentTypeName
                    );
                    let i = index
                  "
                >
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      height: 64px;
                      border-top: 1px solid #dfdfdf;
                      width: 100%;
                    "
                  >
                    <div style="display: flex; align-items: center">
                      <img
                        src="../../../../../assets/icons/pdfdoc.svg"
                        alt="data"
                      />
                      <p
                        style="
                          margin-left: 20px;
                          font-style: normal;
                          font-weight: 400;
                          font-size: 14px;
                          line-height: 16px;
                          color: #505050;
                        "
                      >
                        {{
                          doc.documentPath
                            .split("______")[1]
                            .replaceAll("_", " ")
                        }}
                      </p>
                    </div>
                    <div>
                      <div
                        style="
                          align-items: center !important;
                          gap: 8px;
                          display: flex;
                          justify-content: flex-end;
                        "
                      >
                        <a
                          href="{{ baseUrl }}/public/media/?media={{
                            doc.documentPath
                          }}"
                          target="_blank"
                        >
                          <i class="eye icon"></i>
                        </a>
                        <div
                          class="ui button"
                          style="background-color: #eaeffb; border-radius: 8px"
                          (click)="
                            editLinkedDocument(
                              doc,
                              i,
                              document.documentTypeName
                            )
                          "
                        >
                          Edit
                        </div>
                        <img
                          class="hoverable"
                          src="assets/icons/cancel.svg"
                          (click)="removeLinkedDocument(doc, i)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
            <div style="width: 100%" class="field" appMargin marginT="5px">
              <ng-container
                *ngIf="
                  document.uploadedFiles && document.uploadedFiles.length > 0
                "
              >
                <ng-container
                  *ngFor="
                    let file of document.uploadedFiles;
                    let fileIndex = index
                  "
                >
                  <div
                    fxLayout="row"
                    fxLayoutGap="10px"
                    fxLayoutAlign="start center"
                    appMargin
                    marginB="15px"
                  >
                    <div
                      fxFlex="grow"
                      class="ui segment"
                      style="border-radius: 8px"
                    >
                      <div
                        fxFlex="row"
                        fxLayoutGap="10px"
                        fxLayoutAlign="start center"
                      >
                        <div fxFlex="10">
                          <img
                            src="assets/icons/file-type/doc-upload.svg"
                            alt=""
                          />
                        </div>
                        <div fxFlex="75">
                          <div>
                            {{ file.name }}
                          </div>
                        </div>
                        <div fxFlex fxLayoutAlign="end">
                          <div
                            class="ui button"
                            style="
                              background-color: #eaeffb;
                              border-radius: 8px;
                            "
                            (click)="uploaderEdit.click()"
                          >
                            <input
                              #uploadDoc
                              type="file"
                              accept=".pdf,.doc,.docx,.odf:not(.zip),.xls,.xlsx"
                              #uploaderEdit
                              multiple
                              (change)="editFile($event, document, fileIndex)"
                              placeholder="Edit document"
                              onclick="value = null"
                              style="display: none"
                            />
                            Edit
                          </div>
                          <img
                            class="hoverable"
                            src="assets/icons/cancel.svg"
                            (click)="removeFile(document, fileIndex)"
                          />
                        </div>
                      </div>
                    </div>
                  </div> </ng-container
              ></ng-container>
            </div>
          </div>
        </div>
      </form> -->
    </div>
  </div>
</div>

<div class="actions" style="background: none; border: none">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    appMargin
    marginL="5px"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending || !replyForm.valid"
    (click)="save()"
    autofocus
  >
    Upload
  </button>
</div>
